import { useEffect } from 'react';

const BASE_URL = 'https://marketplacetvde.pt';

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

// Define título, descrição e canonical únicos por página (SEO para SPA).
export function useSeo({ title, description, path = '/', image, noindex = false }) {
  useEffect(() => {
    const canonical = `${BASE_URL}${path}`;
    if (title) {
      document.title = title;
      setMeta('name', 'title', title);
      setMeta('property', 'og:title', title);
    }
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
    }
    if (image) {
      setMeta('property', 'og:image', image.startsWith('http') ? image : `${BASE_URL}${image}`);
      setMeta('name', 'twitter:card', 'summary_large_image');
    }
    setMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    setMeta('property', 'og:url', canonical);
    setCanonical(canonical);
  }, [title, description, path, image, noindex]);
}

// Injecta um bloco JSON-LD (dados estruturados) no <head>, único por id.
export function useJsonLd(id, data) {
  const serialized = JSON.stringify(data);
  useEffect(() => {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = serialized;
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [id, serialized]);
}
